<div class="overlay">
  <div class="spinner-container">
    <div *ngIf="!showProgress" class="spinner-grow" role="status">
      <i class="fas" [ngClass]="getIcon()" aria-hidden="true"></i>
    </div>
    
    <div *ngIf="showProgress" class="progress-container">
      <div class="progress-circle">
        <svg viewBox="0 0 36 36" class="circular-chart">
          <path class="circle-bg"
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path class="circle"
            [attr.stroke-dasharray]="progress + ', 100'"
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <text x="18" y="20.35" class="percentage">{{progress}}%</text>
        </svg>
      </div>
    </div>
  </div>
  
  <p>
    <i *ngIf="type !== 'default'" class="fas" [ngClass]="getIcon()" aria-hidden="true"></i>
    {{ message }}
  </p>
</div>
